import { supabase } from '../supabase';

export const getPayments = () =>
  supabase.from('payments').select('*').order('created_at', { ascending: false });

export const getPayment = (id) =>
  supabase.from('payments').select('*').eq('id', id).single();

export const createPayment = ({ clientName, ...data }) =>
  supabase.from('payments').insert({ ...data, client_name: clientName, created_at: new Date().toISOString() }).select().single();

export const updatePayment = (id, data) =>
  supabase.from('payments').update({ ...data, updated_at: new Date().toISOString() }).eq('id', id);

export const deletePayment = (id) =>
  supabase.from('payments').delete().eq('id', id);

export const getPaymentsByClient = (clientId) =>
  supabase.from('payments').select('*').eq('client_id', clientId).order('created_at', { ascending: false });

export const getPaymentsByBooking = (bookingId) =>
  supabase.from('payments').select('*').eq('booking_id', bookingId).order('created_at', { ascending: false });
